import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {format} from "date-fns";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const CurrentTime = styled('div')({
  fontSize: '1.3rem',
  marginBottom: '1.5rem'
});

const Shift = styled('span')(({ theme }) => ({
  color: theme.primaryColour,
  marginBottom: '1.5rem',
  display: 'block',
  fontSize: 18
}));

const ShiftLabel = styled('span')({
  color: '#333',
  fontSize: 16
});

const TextContainer = styled('div')(({ theme }) => ({
  minWidth: 330,
  [theme.breakpoints.down('sm')]: {
    minWidth: 'auto'
  }
}));

export default function ClockInDialog({open, staff, shift, notes, submitted, shiftComplete, setNotes, handleClose, handleStart, handleEnd }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="max-width-dialog-title"
      fullScreen={fullScreen}
    >
      <DialogTitle id="max-width-dialog-title">Punch Clock - {staff.firstName} {staff.lastName}</DialogTitle>
      <DialogContent>
        <CurrentTime>Time: {format(new Date(), 'H:mm')}</CurrentTime>
        <TextContainer>

          {shift && !shift.active && <div>

            {!shift.unScheduled && <Shift>
              <ShiftLabel>Next Shift: </ShiftLabel>
              {format(new Date(shift.startTime), 'H:mm')} - {format(new Date(shift.endTime), 'H:mm')}{shift.role && <span>, {shift.role}</span>}
              {shift.area && shift.area !== 'N/A' && <span>, {shift.area}</span>}
            </Shift>}

            {notes.ciRequired && <div style={{margin:'-2px 0 4px'}}>
              <TextField
                variant="outlined"
                id="standard-multiline-flexible"
                name="standard-multiline-flexible"
                label="Add an off-schedule clock in note"
                multiline
                maxRows={4}
                rows={3}
                value={notes.clockIn}
                onChange={e => {
                  let inputValue = e.target.value;
                  setNotes(prev => {return {...prev, clockIn: inputValue}});
                }}
                style={{width:'100%'}}
                helperText={submitted && !notes.clockIn && "* note is required"}
                error={submitted && !notes.clockIn}
              />
            </div>}

          </div>}

          {shift && shift.active && <div>

            <Shift>
              Current Shift: {format(new Date(shift.startTime), 'H:mm')} - {format(new Date(shift.endTime), 'H:mm')}</Shift>

            {notes.coRequired && <div style={{margin:'-2px 0 4px'}}>
              <TextField
                variant="outlined"
                id="standard-multiline-flexible2"
                name="standard-multiline-flexible2"
                label="Add an off-schedule clock out note"
                multiline
                maxRows={4}
                rows={3}
                value={notes.clockOut}
                onChange={e => {
                  let inputValue = e.target.value;
                  setNotes(prev => {return {...prev, clockOut: inputValue}});
                }}
                style={{width:'100%'}}
                helperText={submitted && !notes.clockOut && "* note is required"}
                error={submitted && !notes.clockOut}
              />
            </div>}

          </div>}

          {!shift && !shiftComplete && <DialogContentText>
            <Shift>No shifts are scheduled today.</Shift>
          </DialogContentText>}

          {!shift && shiftComplete && <DialogContentText>
            <Shift>Already clocked out of shift.</Shift>
          </DialogContentText>}
        </TextContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          Cancel
        </Button>
        {shift && !shift.active && <Button onClick={handleStart} color="primary" >
          Clock In
        </Button>}
        {shift && shift.active && <Button onClick={handleEnd} color="primary" >
          Clock Out
        </Button>}
      </DialogActions>
    </Dialog>
  );
}
